// test726
(726 && 0);
